module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust331-1200x2490.ca3ee055.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust331-1200x2490.jpg
// module id = 1014
// module chunks = 37